import o from "../components/thumbnail.mjs";
const t = o;
export {
  t as default
};
